import { createFileRoute, redirect } from '@tanstack/react-router';

// The member directory moved to /people; old links (bookmarks, emails,
// entry journeys) keep working. Search params carry over so shared
// filtered views survive the rename.
export const Route = createFileRoute('/_authed/directory/')({
  beforeLoad: ({ location }) => {
    throw redirect({ to: '/people', search: location.search, replace: true });
  },
});
